import { jsx as _jsx } from "react/jsx-runtime";
import FrankensteinHelpTriggerIcon, {} from '@helsenorge/designsystem-react/components/HelpTriggerIcon';
import { getPath } from '@helsenorge/framework-utils/hn-page';
import GenericTrigger from './generic-trigger';
import { Projects, useResources } from '../../../resources';
import useHjelpetekstById from '../../store/hooks/useHjelpetekstById';
import { trackProsesshjelp } from '../../utils/analytics';
/**
 * HelpTriggerIcon med mulighet for HelpBubble/HelpExpanderInline som også kan åpne hjelpeskuffen med spesifikk hjelpetekst for en tjeneste.
 */
const HelpTriggerIcon = props => {
    const { tjenesteNavn = getPath(), hjelpetekstId, useCustomEvent, helpTriggerIconProps } = props;
    const { onClick, ...restTriggerProps } = helpTriggerIconProps || {};
    const { hjelpetekst, isLoading, isError } = useHjelpetekstById(tjenesteNavn, hjelpetekstId, useCustomEvent);
    const resources = useResources(Projects.FRAMEWORK);
    if (isLoading || isError || !hjelpetekst) {
        return null;
    }
    const ariaLabel = helpTriggerIconProps?.ariaLabel || hjelpetekst.visHjelpeskuffTekst || resources?.visHjelpeskuffAriaLabel;
    const handleClick = (event) => {
        trackProsesshjelp('HelpTriggerIcon', ariaLabel);
        if (onClick) {
            onClick(event);
        }
    };
    return (_jsx(GenericTrigger, { triggerComponent: FrankensteinHelpTriggerIcon, triggerProps: {
            ...restTriggerProps,
            ariaLabel: ariaLabel,
            onClick: handleClick,
        }, tjenesteNavn: tjenesteNavn, variant: props.variant, hjelpetekstId: hjelpetekstId, useCustomEvent: useCustomEvent }));
};
export default HelpTriggerIcon;
